// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import OperatingManualNavButtons from "../OperatingManualNavButtons/OperatingManualNavButtons";
import AlgoliaSearch from "src/components/shared/inputs/AlgoliaSearch/AlgoliaSearch";

type OperatingManualSidebarType = {
  isTest?: boolean;
  navbarOptions: Array<{
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }>;
  handleSelectNavbarOption: (option: {
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }) => void;
  handleSelectSubRoute: (
    option: {
      route: string;
      label: string;
    },
    subOption: {
      route: string;
      label: string;
    }
  ) => void;
};

const OperatingManualSidebar = ({
  isTest = false,
  navbarOptions,
  handleSelectNavbarOption,
  handleSelectSubRoute,
}: OperatingManualSidebarType) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        backgroundColor:
          theme.palette.mode === "dark" ? "#4D5063" : "#5B6D7A30",
        borderRadius: "4px",
        width: "100%",
        gap: "20px",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <AlgoliaSearch
        isTest={isTest}
        navbarOptions={navbarOptions}
        handleSelectNavbarOption={handleSelectNavbarOption}
        handleSelectSubRoute={handleSelectSubRoute}
      />

      <OperatingManualNavButtons
        navbarOptions={navbarOptions}
        handleSelectNavbarOption={handleSelectNavbarOption}
        handleSelectSubRoute={handleSelectSubRoute}
      />
    </Box>
  );
};

export default OperatingManualSidebar;
